// This file is auto-generated by CS->TS converter
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ApiConfigurationService {

    // Base URL for all underlying controllers' requests
    rootUrl = "/";
};
